import { SxProps } from "@mui/material";
import { memo, forwardRef } from "react";
import FormControl from "@mui/material/FormControl";
import TextField, { TextFieldProps } from "@mui/material/TextField";

import ValidationHelperText from "../validation-helper-text";

type CustomTextFieldProps = TextFieldProps & {
    errorMessage?: string;
    validationHelperTextSX?: SxProps;
};

const LtrTextField = forwardRef<HTMLInputElement, CustomTextFieldProps>(({ inputProps, errorMessage, ...props }, ref) => {
    return (
        <FormControl fullWidth>
            <TextField
                fullWidth
                error={Boolean(errorMessage)}
                inputProps={{ dir: "ltr", ...inputProps }}
                inputRef={ref}
                {...props}
            />
            {errorMessage &&
                <ValidationHelperText
                    helperText={errorMessage}
                    error={Boolean(errorMessage)}
                />
            }
        </FormControl>
    );
});
LtrTextField.displayName = "LtrTextField";
export default memo(LtrTextField);